import orionGetAuthHeaders from '@orion-js/graphql-client/lib/auth/getAuthHeaders'

export default function getAuthHeaders(body) {
  return {
    ...orionGetAuthHeaders(body),
    'Content-Type': 'application/json'
  }
}
